<template>
  <Container class="mt-22.75 gap-5 md:mt-26.25 xl:mt-30 xl:gap-10 2xl:mt-35!">
    <PublicationSlider
      :slides="publicationData"
      :slider-title="sectionData.title"
      :link="sectionData.url"
      :target="sectionData.target"
    />
  </Container>
</template>

<script setup lang="ts">
import type { HomepageSection, Publication } from '~/types'

interface Props {
  sectionData: HomepageSection<Publication>
}

const props = defineProps<Props>()

const publicationData = computed(() => props.sectionData?.items)
</script>
